import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from "dayjs/plugin/duration";
import { DEFAULT_DATE } from './name-space';

dayjs.extend(utc);
dayjs.extend(duration);
export const now = (aData: string = '', aFormat: string = DEFAULT_DATE) => {
  return aData ? dayjs(aData).utc().format(aFormat) : dayjs.utc().format(aFormat);
};

export const diffNowDay = (aTarget: string): boolean => {
  if (dayjs().isAfter(now(aTarget))) {
    return true; // 과거
  } else return false; // 미래
};
